import UseraddressDataStorage from "./useraddressDataStorage";
import { toUseraddressJson } from "./useraddressJsonConvert";
const isJSON = (str) => {
    try {
        JSON.parse(str);
        return true;
    }
    catch (err) {
        return false;
    }
};
class UseraddressJsonStorage {
    useraddressDataStorage;
    constructor(feedbackDataStorage) {
        this.useraddressDataStorage = feedbackDataStorage;
    }
    static create(avalancheProvider) {
        return new this(new UseraddressDataStorage(avalancheProvider));
    }
    async getAllUserAddress() {
        const data = await this.useraddressDataStorage.get();
        if (data === undefined) {
            return undefined;
        }
        const objects = data
            .filter((k) => k !== "")
            .map((k) => JSON.parse(k))
            .filter((o) => o !== undefined)
            .filter((o) => typeof o === "object" && o.useraddress.address !== "");
        return objects;
    }
    async createUseraddressData(toStore) {
        const data = toUseraddressJson(toStore);
        await this.useraddressDataStorage.set(toStore.address, data);
    }
    async updateUseraddressData(toStore) {
        const data = toUseraddressJson(toStore);
        await this.useraddressDataStorage.set(toStore.address, data);
    }
}
export default UseraddressJsonStorage;
